import { render, staticRenderFns } from "./ExtendedImage.vue?vue&type=template&id=04ab63e8&"
import script from "./ExtendedImage.vue?vue&type=script&lang=js&"
export * from "./ExtendedImage.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports